export default __webpack_public_path__ + "static/media/menu.7dbc32cb.svg";